import { Inject, Injectable } from '@angular/core';

import { HttpInterceptorService } from '@ispm/core/services/http-interceptor.service';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { AuditSearchRequestDTO } from '../classes/audit-search-request';
import { AuditSearchResponseDTO } from '../classes/audit-search-response';



@Injectable()
export class AuditViewerService {


  constructor(private _http: HttpInterceptorService,
             ) {


  }

  public searchAudits(  auditSearchRequestDTO: AuditSearchRequestDTO ): Observable<AuditSearchResponseDTO> {
    return this._http.post<AuditSearchResponseDTO>('/api/searchaudit', auditSearchRequestDTO, true)
      .pipe(
        map(r => r.body)
      );
  }
}
